export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-hd-line',
      title: '1080P 高清',
      desc: '全高清画质，支持多种清晰度选择',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速播放',
      desc: 'CDN 加速技术，流畅不卡顿',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      desc: '手机、平板、电脑全平台支持',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无广告',
      desc: '绿色观影环境，专注电影体验',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-900">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat) => (
            <div key={feat.title} className="flex flex-col items-center text-center p-5 rounded-lg bg-background-800/50 border border-background-700/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-400 mb-3">
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-1">{feat.title}</h3>
              <p className="text-xs text-foreground-500">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}